/*
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-08-31 20:13:49
 * @LastEditTime: 2021-09-23 15:13:51
 * @Description: file content
 */

import store from "@/store";

/**
 * @description: 检查路由的路径是否是微应用
 * @param {*} path 路径
 * @return {*}
 */
export function checkIsMircApp(path) {
  if (path && path.length > 0) {
    const mircAppDic = store.getters && store.getters.mircAppDic;
    let isMircApp = false;
    for (let key in mircAppDic) {
      if (key.indexOf("/") === -1) {
        key = `/${key}`;
      }
      if (path.indexOf(key) === 0) {
        isMircApp = true;
      }
    }
    return isMircApp;
  }
  return false;
}

/**
 * @description: 获取所有微应用需要定义在body里的class
 * @param {*}
 * @return {*}
 */
export function mircAppBodyClassList() {
  const mircAppDic = store.getters && store.getters.mircAppDic;
  const classList = [];
  for (const key in mircAppDic) {
    const item = mircAppDic[key];
    if (item["bodyClass"]) {
      classList.push(item["bodyClass"]);
    }
  }
  return classList;
}

/**
 * @description: 获取某个微应用需要定义在body里的class名称
 * @param {*} path,路由路径
 * @return {*}
 */
export function getMircAppBodyClass(path) {
  let className = "";
  if (path && path.length > 0) {
    const mircAppDic = store.getters && store.getters.mircAppDic;
    for (let key in mircAppDic) {
      const item = mircAppDic[key];
      if (key.indexOf("/") === -1) {
        key = `/${key}`;
      }
      if (path.indexOf(key) === 0) {
        className = item["bodyClass"];
      }
    }
  }
  return className;
}
